import { useCallback } from "react"

import { useDateFormatter } from "../../../hooks/use-date-formatter.tsx"

export const TIME_FORMAT = "h:mm A"

/** "PDT" for the account's zone at that instant; the IANA name if the browser can't abbreviate it. */
export const zoneAbbreviation = (timezone: string, at: Date = new Date()) => {
  try {
    const part = new Intl.DateTimeFormat("en-US", {
      timeZone: timezone,
      timeZoneName: "short"
    })
      .formatToParts(at)
      .find((item) => item.type === "timeZoneName")
    return part?.value ?? timezone
  } catch {
    return timezone
  }
}

export const useStamp = () => {
  const { formatDate, dateFormat, timezone } = useDateFormatter()
  const date = useCallback(
    (value: string | null | undefined) =>
      value ? String(formatDate(value, dateFormat)) : "",
    [formatDate, dateFormat]
  )
  const time = useCallback(
    (value: string | null | undefined) =>
      value ? String(formatDate(value, TIME_FORMAT)) : "",
    [formatDate]
  )
  const stamp = useCallback(
    (value: string | null | undefined) =>
      value ? `${date(value)} ${time(value)}` : "",
    [date, time]
  )
  const scheduled = useCallback(
    (value: string | null | undefined) =>
      value
        ? `${stamp(value)} ${zoneAbbreviation(timezone, new Date(value))}`
        : "",
    [stamp, timezone]
  )
  return { date, time, stamp, scheduled, timezone, dateFormat }
}
